import React from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

const StartInfoGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/auth/signin" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default StartInfoGuard;
